import { styled } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../../helix';
/**
 * Styled label for FieldLabel.
 */
export const StyledLabel = styled('label')(() => (Object.assign(Object.assign(Object.assign({}, HelixStyles.style_07), HelixStyles.truncate), { color: HelixPalette.neutral90, whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', gap: '0.25rem' })));
